<template>
  <div>
    <div class="main">
      <h3>Основная информация</h3>
      <div class="main-content">
        <loading v-if="loading"></loading>
        <div v-if="!loading">
          <el-row :gutter="24">
            <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="el-card box-card is-always-shadow mb-4">
                <div class="el-card__header">
                  <div class="clearfix">
                    <span>Статистика</span>
                  </div>
                </div>
                <div class="el-card__body">
                  <span>Автомобили: <strong class="text-primary">{{ cars_items }}</strong> / <strong class="text-primary">{{ formatSize(cars_filesize) }}</strong></span><br>
                  <span>Тюнинг/Экстерьер: <strong class="text-primary">{{ tuning_items }}</strong> / <strong class="text-primary">{{ formatSize(tuning_filesize) }}</strong></span><br>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {axios} from "@/api";
import Loading from "@/components/Loading";

export default {
  name: 'Home',
  data() {
    return {
      loading: true,
      controller: 'user/stat/png',
      cars_items: 0,
      tuning_items: 0,
      cars_filesize: 0,
      tuning_filesize: 0
    };
  },
  components: {
    Loading,
  },
  methods: {
    async getStat() {
      try {
        this.loading = true;

        await axios.get(`${process.env.VUE_APP_API_V1}/${this.controller}`)
            .then((response) => {
              console.log(JSON.stringify(response.data));
              this.cars_items = response.data.item.cars_items;
              this.tuning_items = response.data.item.tuning_items;
              this.cars_filesize = response.data.item.cars_filesize;
              this.tuning_filesize = response.data.item.tuning_filesize;
            })
            .catch((error) => {
              console.log(error);
            });

        this.loading = false;
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для доступа к данной статистике'
          });
        }
      }
    },
    formatSize(fileSize) {
      if (fileSize<1000000000) {
        if (fileSize < 1000000) {
          if (fileSize < 1000) {
            return fileSize + ' b';
          } else {
            return Math.ceil(fileSize / 1000) + ' kb';
          }
        } else {
          return Math.ceil(fileSize / 1000000) + ' Mb';
        }
      } else {
        return Math.ceil(fileSize / 1000000000) + ' Gb';
      }
    },
  },
  async mounted() {
    await this.getStat();
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
